import get from "lodash.get";
import MapConfig from "services/map/MapConfig";
import moment from "moment";

require("moment-timezone");

class ContractUtils {
  static shouldHideOnCurrentTab = (path) => {
    const hideOnTabs = [];
    return hideOnTabs.indexOf(path) >= 0;
  };

  static getParkMaxDaysAllowed = (contract) =>
    get(
      contract,
      "max_days_allowed_park_live",
      get(MapConfig, "park.defaultMaxDaysAllowed")
    );

  static getPedestrianMaxDaysAllowed = (contract) => {
    return get(
      contract,
      "max_days_allowed_pedestrian_history",
      get(MapConfig, "pedestrian.defaultMaxDaysAllowed")
    );
  };

  static getMaxDaysAllowedHeatmapOccupancy = (contract) => {
    return get(
      contract,
      "max_days_allowed_park_heatmap",
      get(MapConfig, "park.defaultMaxDaysAllowedHeatmapOccupancy")
    );
  };

  static getCustomAnalysisMaxDaysAllowed = (contract) =>
    get(
      contract,
      "max_days_allowed_customAnalysis",
      get(MapConfig, "customAnalysis.defaultMaxDaysAllowed")
    );

  static getFlowMaxDaysAllowed = (contract) =>
    get(
      contract,
      "max_days_allowed_flow",
      get(MapConfig, "flow.defaultMaxDaysAllowed")
    );

  static formatTimestamp = (contract, timestamp) => {
    return moment
      .unix(timestamp)
      .tz(contract?.timezone ?? "Europe/Paris")
      .format("YYYY-MM-DD HH_mm");
  };
}

export default ContractUtils;
